import { useTranslate } from "ra-core";
import { cn } from "@/lib/utils";

import type { ProjectAccess } from "../types";

export type AccessChoice = ProjectAccess | "none";

const CHOICES: AccessChoice[] = ["none", "own", "department", "all"];

/** What an employee sees in a project: nothing, own records, the department's, all. */
export const AccessSelect = ({
  value,
  onChange,
  label,
  allowNone = true,
  className,
}: {
  value: AccessChoice;
  onChange: (value: AccessChoice) => void;
  /** accessible name, e.g. the project or the employee */
  label: string;
  allowNone?: boolean;
  className?: string;
}) => {
  const translate = useTranslate();
  return (
    <select
      aria-label={label}
      value={value}
      onChange={(event) => onChange(event.target.value as AccessChoice)}
      className={cn(
        "h-8 rounded-md border bg-card px-2 text-sm",
        value === "none" && "text-muted-foreground",
        className,
      )}
    >
      {CHOICES.filter((choice) => allowNone || choice !== "none").map(
        (choice) => (
          <option key={choice} value={choice}>
            {translate(`crm.projects.access.${choice}`)}
          </option>
        ),
      )}
    </select>
  );
};
